'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _redux = require('redux');

var _shipping_template = require('../actions/shipping_template');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
    isFetching: false,
    didInvalidate: false,
    items: []
};
var shippingTemplates = function shippingTemplates() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _shipping_template.INVALIDATE_SHIPPING_TEMPLATES:
            return _extends({}, state, {
                didInvalidate: true
            });
        case _shipping_template.REQUEST_SHIPPING_TEMPLATES:
            return _extends({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case _shipping_template.RECEIVE_SHIPPING_TEMPLATES:
            return _extends({}, state, {
                isFetching: false,
                didInvalidate: false,
                items: action.shippingTemplates,
                lastUpdated: action.received_at
            });
        case _shipping_template.FAILURE_SHIPPING_TEMPLATES:
            return _extends({}, state, {
                isFetching: false,
                error: action.error
            });
        default:
            return state;
    }
};

var shippingTemplateReducer = (0, _redux.combineReducers)({
    shippingTemplates: shippingTemplates
});

exports.default = shippingTemplateReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/shipping_template.js
// module id = 899
// module chunks = 0